"use client";

import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/shared/components/ui/alert-dialog";
import { Button } from "@/shared/components/ui/button";
import { UserMinus, X } from "lucide-react";
import { TableRowDetailsItem } from "../../../types";

interface CancelInvitationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  item: TableRowDetailsItem;
}

export default function CancelInvitationModal({
  isOpen,
  onClose,
  onConfirm,
  item,
}: CancelInvitationModalProps) {
  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  return (
    <AlertDialog open={isOpen} onOpenChange={onClose}>
      <AlertDialogContent
        className="rounded-xl max-w-[420px] gap-[16px]"
        style={{
          zIndex: 999,
        }}
      >
        {/* Close Button */}
        <Button
          variant="ghost"
          size="icon"
          className="w-[30px] h-[30px] absolute top-4 right-4 cursor-pointer hover:bg-accent"
          onClick={onClose}
        >
          <X
            style={{ width: "16px", height: "16px", strokeWidth: 1.5 }}
            className="cursor-pointer"
          />
        </Button>

        {/* Icon */}
        <div className="flex">
          <div className="w-10 h-10 bg-white border border-border rounded-lg flex items-center justify-center shrink-0">
            <UserMinus className="w-[22px] h-[22px] text-foreground" />
          </div>
        </div>

        {/* Content */}
        <div className="text-left">
          <div className="text-[18px] font-700 leading-7 text-card-foreground tracking-[-0.45px] mb-[8px]">
            {item.user.name} davetini iptal etmek istiyor musunuz?
          </div>
          <div className="text-sm font-500 leading-5 text-muted-foreground text-left">
            Bu kişinin daveti iptal edilecek ve davet bağlantısı artık
            kullanılamayacak.
            <br />
            <br />
            Tekrar katılabilmesi için yeni bir davet göndermeniz gerekir
          </div>
        </div>

        {/* Footer */}
        <AlertDialogFooter className="gap-2 flex justify-end mt-4">
          <AlertDialogCancel className="!w-auto  h-9 px-[16px] py-2 rounded-md border border-border bg-white text-foreground font-600 text-sm hover:bg-accent">
            İptal et
          </AlertDialogCancel>
          <Button
            variant="destructive"
            onClick={handleConfirm}
            className="!w-auto h-9 px-[16px] py-2 rounded-md bg-destructive text-destructive-foreground font-600 text-sm hover:bg-destructive/90"
          >
            Daveti iptal et
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
